import { OpenAPI, SupplierSearchField, SupplierService } from "../api/generated"

OpenAPI.BASE = import.meta.env.VITE_API_ENDPOINT
export async function getSupplierSearch(
  field: "supplierName" | "supplierNumber",
  searchString: string,
  opco: string,
) {
  let mode = SupplierSearchField.SUPPLIER_NUMBER
  if (field === "supplierName") {
    mode = SupplierSearchField.SUPPLIER_NAME
  }

  let data = SupplierService.searchSuppliersSuppliersSearchGet(
    mode,
    searchString,
    opco,
  )

  return data
}
